/*
 * The API's base path (docs/API.md → Common). A leaf module on its own: the fetch store
 * re-exports it, and every address the console builds for an <img> or a download reads it here.
 */
export const API_BASE_URL = '/api/tv-api/v1'
